var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"dense":""}},_vm._l((_vm.items),function(item,idx){return _c('v-col',{key:idx,attrs:{"cols":"12","sm":"6","md":"4","lg":"3","xl":"2"}},[_vm._t("default",null,{"item":item})],2)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }